(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ff-fabric-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ff-fabric-videos')) {
    customElements.define('ff-fabric-videos', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.dialog = this.querySelector('dialog');
        this.player = this.querySelector('[data-video-player]');
        if (!this.dialog || !this.player) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-video-template]');
          if (trigger) this.openVideo(trigger);
          const mobileTrigger = event.target.closest('[data-video-open-first]');
          if (mobileTrigger) {
            const firstVideo = this.querySelector('.ff-fabric-videos__card[data-video-template]');
            if (firstVideo) this.openVideo(firstVideo, mobileTrigger);
          }
          if (event.target.closest('[data-video-close]')) this.dialog.close();
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => this.clearVideo(), options);
      }
      openVideo(trigger, returnFocus = trigger) {
        const template = document.getElementById(trigger.dataset.videoTemplate);
        if (!template) return;
        if (!this.dialog.open) this.trigger = returnFocus;
        this.player.querySelectorAll('video').forEach((video) => video.pause());
        this.player.replaceChildren(template.content.cloneNode(true));
        this.querySelectorAll('[data-video-switch]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.videoTemplate === trigger.dataset.videoTemplate));
        });
        if (!this.dialog.open) {
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
        }
        const video = this.player.querySelector('video');
        document.querySelectorAll('hdt-product-media video').forEach((galleryVideo) => galleryVideo.pause());
        if (video) video.play().catch(() => {});
      }
      clearVideo() {
        this.player.querySelectorAll('video').forEach((video) => video.pause());
        this.player.replaceChildren();
        if (this.previousOverflow !== undefined) {
          document.documentElement.style.overflow = this.previousOverflow;
          this.previousOverflow = undefined;
        }
        if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        if (this.player) this.clearVideo();
        this.events?.abort();
        this.events = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
